import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend'; // Loads translation files

i18n
  .use(Backend) // Load translations from public/locales folder
  .use(LanguageDetector) // Detect user language
  .use(initReactI18next) // Pass i18n instance to react-i18next
  .init({
    fallbackLng: 'en', // Default language
    debug: true, // Enable debug mode in console
    interpolation: {
      escapeValue: false // React already protects against XSS
    },
    backend: {
      loadPath: '/locales-language/{{lng}}.json' // Load translations dynamically
    }
  });

export default i18n;
